<div class="row justify-content-center">
    <div class="col-lg-8">
        <div class="card">

            <div class="card-body">
                <form [formGroup]="evaluatedForm" (ngSubmit)="create()">
                    <div class="form-body">
                        <h4 class="card-title">Configuración de prueba</h4>
                        <hr class="hr-gray" >
                        <div class="row form-material">
                          <div class="col-12 mb-5 switch-container">
                            <div class="row">
                              <div class="col-6">
                                <div class="demo-switch-title">Prueba local</div>
                                <div class="switch">
                                  <label>
                                    <input [(ngModel)]="isLocal" type="checkbox" [ngModelOptions]="{standalone: true}" ><span
                                      class="lever switch-col-indigo"></span>
                                  </label>
                                  <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">Seleccionando esta opción no se enviará notificación vía email al evaluado, 
                                    la prueba se iniciará desde la pc del evaluador.</span></label>
                                </div>
                              </div>
                              <div *ngIf="user && user.isCustomBrand" class="col-6">
                                <div class="demo-switch-title">Usar evaluapsi.com</div>
                                <div class="switch">
                                  <label>
                                    <input [(ngModel)]="useEvaluapsi" [ngModelOptions]="{standalone: true}"(ngModelChange)='updateHTML()' type="checkbox"><span class="lever switch-col-indigo"></span>
                                  </label>
                                  <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">Seleccionando esta opción, la notificación vía email de la asignación 
                                    de la/s prueba/s serán al dominio: EvaluaPsi.</span></label>
                                </div>
                              </div>
                              <div *ngIf="!isLocal" class="col-6">
                                <div class="demo-switch-title">Personalizar envío</div>
                                <div class="switch">
                                  <label>
                                    <input (click)="defaultEmail=!defaultEmail; checkState()" [ngModel]="!defaultEmail" [ngModelOptions]="{standalone: true}" type="checkbox"  ><span class="lever switch-col-indigo"></span>
                                  </label>
                                  <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">Aquí podrá personalizar el cuerpo y asunto del email a enviar (Asunto, Tu email y Mensaje de bienvenida).</span></label>
                                </div>
                              </div>
                              <div class="col-6">
                                <div class="demo-switch-title">Sistema anti-trampa


                                </div>
                                <div class="switch">
                                    <label>
                                        <input [(ngModel)]="secureTests" [ngModelOptions]="{standalone: true}" type="checkbox" [checked]="secureTests"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">Esta acción solo aplica a las 14 Evaluaciones psicométricas. Si activa este elemento, el evaluado no podrá minimizar ni cambiar de ventana, si lo hace, la prueba será bloqueada. Como evaluador usted será notificado por email de dicho "bloqueo", y luego tendrá que "desbloquear" al evaluado para que éste pueda volver a tomarla desde el principio. </span></label>

                                </div>
                              </div>

                            </div>
                            <div *ngIf="user && user.isCustomBrand && !useEvaluapsi" class="row jcc">
                              <button type="button" class="btn btn-primary btn-rounded waves-effect btn-sm mt-3" (click)="shareBrandLink()">
                                Copiar Link Manual
                              </button>
                              <label class="mytooltip button-tooltip pointer"><b class="text-info"><small><b>?</b></small></b><span class="tooltip-content4">Esta opción copia el enlace de acceso para enviar manualmente a 
                                sus evaluados (el sistema lo hace en forma automática) o si desea
                                compartir con otro evaluador a: mievaluado.com (dominio anónimo)</span></label>

                            </div>



                            <div *ngIf="!defaultEmail" class="row justify-content-center mt-3">
                              <div class="col-md-6 form-material">
                                  <div class="form-group mb-2">
                                      <input [(ngModel)]="subject" [ngModelOptions]="{standalone: true}" autocomplete="off" type="text"   class="form-control" placeholder="Asunto del email">
                          
                                  </div>
                              </div>
                              <div class="NgxEditor__Wrapper m-b-40 col-12">
                                  <ngx-editor-menu [editor]="editor"> </ngx-editor-menu>
                                  <ngx-editor
                                    [editor]="editor"
                                    [(ngModel)]="html"
                                    [placeholder]="'Escriba su texto...'"
                                    [ngModelOptions]="{standalone: true}"
                                  ></ngx-editor>
                              </div>
                            </div>



                          </div>
                          <div class="col-12">
                              <h4 class="card-title">Datos del evaluado</h4>
                              <hr class="hr-gray">

                          </div>
                            <div *ngIf="!isLocal" class="col-md-6">
                                <div class="form-group">
                                    <input formControlName="email" autocomplete="off" autocomplete="off" (focusout)="handleFocusEmail()" type="email"   class="form-control" placeholder="Email">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">

                                    <input [readOnly]="exists" autocomplete="off" formControlName="name" type="text"  class="form-control" placeholder="Nombre">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="surname" type="text"  class="form-control" placeholder="Apellido">
                                </div>
                            </div>
                            <div *ngIf="!isLocal" class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists||!pswEdit" (ngModelChange)="updateHTML()" autocomplete="off" formControlName="password" type="text" class="form-control" placeholder="Contraseña">
                                    <span *ngIf="!exists" class="help-block text-muted"><small>Contraseña <a href="javascript:void(0)" (click)="pswEdit=!pswEdit" class="text-danger">EDITAR</a></small></span>
                                </div>
                            </div>
                             <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="country" type="text"  class="form-control" placeholder="País">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="city" type="text"  class="form-control" placeholder="Localidad">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">

                                    <input [readOnly]="exists" autocomplete="off" formControlName="company" type="text"  class="form-control" placeholder="Empresa">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">

                                    <input [readOnly]="exists" autocomplete="off" formControlName="profession" type="text"  class="form-control" placeholder="Profesión">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="notes" type="text"  class="form-control" placeholder="Observaciones">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group row">

                                    <div class="col-10">
                                        <input [readOnly]="exists" formControlName="birthDate" [value]="newDate" class="form-control" type="date" id="example-date-input">
                                        <span class="help-block text-muted"><small>Fecha de nacimiento</small></span>
                                    </div>
                                </div>

                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <select class="form-control" formControlName="sex">
                                        <option [disabled]="exists" selected value="Masculino">Masculino</option>
                                        <option [disabled]="exists" value="Femenino">Femenino</option>
                                    </select>
                                    <span class="help-block text-muted"><small>Sexo</small></span>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="phone" type="text"  class="form-control" placeholder="Teléfono">
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <input [readOnly]="exists" autocomplete="off" formControlName="studies" type="text"  class="form-control" placeholder="Grado de estudios">
                                </div>
                            </div>

                            <div class="col-12 m-b-10">
                                <h6 *ngIf="exists" class="text-center text-success">Datos de usuario ya ingresados en el sistema</h6>
                            </div>
                        </div>
                        <!--/row-->

                        <h4 class="card-title">Evaluaciones psicométricas</h4>
                        <hr class="hr-gray">

                        <div class="row">
                            <div class="col-sm-3">
                                <div class="demo-switch-title">16pf <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('16PF')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="pf16" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.pf16" type="checkbox" id="basic_checkbox_2" formControlName="pf16Photo" >
                                        <label *ngIf="evaluatedForm.value.pf16" for="basic_checkbox_2">Foto (1 crédito)</label>


                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Cleaver <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('CLEAVER')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="cleaver" type="checkbox"[checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <br *ngIf="evaluatedForm.value.cleaver" >
                                        <input *ngIf="evaluatedForm.value.cleaver" type="checkbox" id="basic_checkbox_3" formControlName="cleaverPhoto" >
                                        <label *ngIf="evaluatedForm.value.cleaver" for="basic_checkbox_3">Foto (1 crédito)</label>
                                        <br>

                                        <input *ngIf="evaluatedForm.value.cleaver" type="checkbox" id="hf" [(ngModel)]="useCleaverHF" [ngModelOptions]="{standalone: true}" >
                                        <label *ngIf="evaluatedForm.value.cleaver" for="hf">Factor humano (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Terman <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('TERMAN')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="terman" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.terman" type="checkbox" id="basic_checkbox_4" formControlName="termanPhoto" >
                                        <label *ngIf="evaluatedForm.value.terman" for="basic_checkbox_4">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">AllPort <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('ALL PORT')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="allPort" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.allPort" type="checkbox" id="basic_checkbox_5" formControlName="allPortPhoto" >
                                        <label *ngIf="evaluatedForm.value.allPort" for="basic_checkbox_5">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Kostick <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('KOSTIK')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="kostick" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.kostick" type="checkbox" id="basic_checkbox_6" formControlName="kostickPhoto" >
                                        <label *ngIf="evaluatedForm.value.kostick" for="basic_checkbox_6">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Ipv <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('IPV')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="ipv" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.ipv" type="checkbox" id="basic_checkbox_7" formControlName="ipvPhoto" >
                                        <label *ngIf="evaluatedForm.value.ipv" for="basic_checkbox_7">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Zavic <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('ZAVIC')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="zavic" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.zavic" type="checkbox" id="basic_checkbox_8" formControlName="zavicPhoto" >
                                        <label *ngIf="evaluatedForm.value.zavic" for="basic_checkbox_8">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Barsic <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('BARSIC')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="barsit" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                        <input *ngIf="evaluatedForm.value.barsit" type="checkbox" id="basic_checkbox_9" formControlName="barsitPhoto" >
                                        <label *ngIf="evaluatedForm.value.barsit" for="basic_checkbox_9">Foto (1 crédito)</label>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">MMPI 2 <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('MMPI2')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="mmpi2" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.mmpi2" type="checkbox" id="basic_checkbox_10" formControlName="mmpi2Photo" >
                                    <label *ngIf="evaluatedForm.value.mmpi2" for="basic_checkbox_10">Foto (1 crédito)</label>
                                    <input *ngIf="evaluatedForm.value.mmpi2" type="checkbox" id="basic_checkbox_1" [(ngModel)]="mmpi2Extra" [ngModelOptions]="{standalone:true}">
                                    <label *ngIf="evaluatedForm.value.mmpi2" for="basic_checkbox_1">Version abreviada</label>
                                    <div *ngIf="evaluatedForm.value.mmpi2" class="form-group">
                                        <label  for="">Baremo seleccionado:</label>
                                        <select class="form-control" *ngIf="evaluatedForm.value.mmpi2" (change)="setBaremo($event)" [(NgModel)]="baremo" [ngModelOptions]="{standalone:true}">
                                            <option value="Argentina">Argentina</option>
                                            <option value="España">España</option>
                                            <option value="Mexico">México</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                            <div class="col-sm-3">
                                <div class="demo-switch-title">MMPI A <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('MMPIA')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="mmpia" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.mmpia" type="checkbox" id="basic_checkbox_11" formControlName="mmpiaPhoto" >
                                    <label *ngIf="evaluatedForm.value.mmpia" for="basic_checkbox_11">Foto (1 crédito)</label>
                                    <input *ngIf="evaluatedForm.value.mmpia" type="checkbox" id="basic_checkbox_12" [(ngModel)]="mmpiaExtra" [ngModelOptions]="{standalone:true}">
                                    <label *ngIf="evaluatedForm.value.mmpia" for="basic_checkbox_12">Version abreviada</label>
                                    <div *ngIf="evaluatedForm.value.mmpia" class="form-group">
                                        <label  for="">Baremo seleccionado:</label>
                                        <select class="form-control" *ngIf="evaluatedForm.value.mmpia" (change)="setBaremo($event)" [(NgModel)]="baremo" [ngModelOptions]="{standalone:true}">
                                            <option value="Argentina">Hispano</option>
                                        </select>
                                    </div>
                                </div>
                            </div>      
                            <div class="col-sm-3">
                                <div class="demo-switch-title">MIPS <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('MIPS')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="mips" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.mips" type="checkbox" id="basic_checkbox_13" formControlName="mipsPhoto" >
                                    <label *ngIf="evaluatedForm.value.mips" for="basic_checkbox_13">Foto (1 crédito)</label>
                                    <div *ngIf="evaluatedForm.value.mips" class="form-group">
                                        <label  for="">Baremo seleccionado:</label>
                                        <select class="form-control" *ngIf="evaluatedForm.value.mips" (change)="setBaremo($event)" [(NgModel)]="baremo" [ngModelOptions]="{standalone:true}">
                                            <option value="Argentina">Argentina</option>
                                            <option value="España">España</option>
                                            <option value="Mexico">Mexico</option>
                                        </select>
                                    </div>
                                </div>
                            </div>     
                            <div class="col-sm-3">
                                <div class="demo-switch-title">BIS-11 <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('BIS11')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="bis11" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.bis11" type="checkbox" id="basic_checkbox_14" formControlName="bis11Photo" >
                                    <label *ngIf="evaluatedForm.value.bis11" for="basic_checkbox_14">Foto (1 crédito)</label>
                                </div>
                            </div>    
                            <div class="col-sm-3">
                                <div class="demo-switch-title">Chaside <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('CHASIDE')" >?</b></div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="chaside" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.chaside" type="checkbox" id="basic_checkbox_15" formControlName="chasidePhoto" >
                                    <label *ngIf="evaluatedForm.value.chaside" for="basic_checkbox_15">Foto (1 crédito)</label>
                                </div>
                            </div>   
                            
                            <div class="col-sm-3">
                              <div class="demo-switch-title">Test Domino <b class="text-info pointer" title="Información sobre la prueba" (click)="handleShowInfo('DOMINO')" >?</b></div>
                              <div class="switch">
                                  <label>
                                      <input formControlName="domino" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span></label>
                                      <input *ngIf="evaluatedForm.value.domino" type="checkbox" id="basic_checkbox_4" formControlName="dominoPhoto" >
                                      <label *ngIf="evaluatedForm.value.domino" for="basic_checkbox_4">Foto (1 crédito)</label>
                              </div>
                            </div>

                            <div class="col-sm-3">
                            </div>



                            <div class="col-12 py-3"></div>

                            <div class="col-sm-3 text-center">
                                <div class="demo-switch-title">Killer Questions

                                  <label class="mytooltip"><b class="text-info">?</b><span class="tooltip-content4">El Formulario Killer Questions, permite cargar preguntas de: texto, numéricas y opciones para que los evaluados respondan en un máximo de 40 minutos antes de realizar pruebas adicionales.</span></label>

                                </div>
                                <div class="switch">
                                    <label>
                                        <input formControlName="form" type="checkbox" [checked]="false"><span class="lever switch-col-indigo"></span>
                                    </label>
                                    <input *ngIf="evaluatedForm.value.form" type="checkbox" id="basic_checkbox_16" formControlName="formPhoto" >
                                    <label *ngIf="evaluatedForm.value.form" for="basic_checkbox_16">Foto (1 crédito)</label>
                                </div>
                                <a *ngIf="evaluatedForm.value.form" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn-info btn-rounded text-white mytooltip btn-sm" href="javascript:void(0)" style="z-index: 10;" data-toggle="modal" data-target="#formModal">Seleccionar/crear<span class="tooltip-content4">Asigne a cada evaluado el mismo <b>formulario + etiqueta</b>, si desea agrupar evaluados de una misma empresa/organización. (Si luego elimina la etiqueta de alguno/s, lo/s desvinculará del grupo).</span></a>
                                <p *ngIf="evaluatedForm.value.form" class="text-center color-primary mt-3"><small><b>{{formTitle ? formTitle : 'Ninguno seleccionado'}}</b></small></p>
                              </div>    
                            </div>     
                            <div *ngIf="evaluatedForm.value.form" class="col-sm-3 mt-3">
                              <div class="form-material">
                                <div class="form-group">
                                    <input autocomplete="off" [(ngModel)]="defaultTag" [ngModelOptions]="{standalone: true}" type="text" class="form-control" placeholder="Etiqueta">
                                </div>
                              </div>
                            </div>           
                    </div>
                    <div *ngIf="user && user.canUseCustomTests">
                        <h4 class="card-title mt-5">Evaluaciones cognitivo - laboral</h4>
                        <hr class="hr-gray">

                         <div class="col-md-6 form-material">
                              <div class="form-group">
                                  <select class="form-control" [(ngModel)]="testGroup" (ngModelChange)="getCustomTests()" [ngModelOptions]="{standalone: true}">
                                      <option *ngFor="let group of groups" [value]="group._id">{{group.title}}</option>
                                  </select>
                                  <span class="help-block text-muted"><small>Grupos de pruebas</small></span>
                              </div>
                          </div>
                          <div class="col-12"></div>
        
                          <div class="row">
                            <div *ngFor="let test of selectedTests; index as i" class="col-sm-4">
                              <div class="demo-switch-title">{{test.title}}</div>
                              <div class="switch">
                                  <label>
                                      <input (ngModelChange)="toggleCustomTests()" [(ngModel)]="checkedCustomTests[i]" [ngModelOptions]="{standalone: true}" type="checkbox" [checked]="checkedCustomTests[i]"><span class="lever switch-col-indigo"></span>
                                  </label>

                                  <input *ngIf="checkedCustomTests[i]" type="checkbox" [id]="'basic_checkbox_4'+i" [ngModelOptions]="{standalone: true}" [(ngModel)]="customTestsPhotos[i]" >
                                  <label *ngIf="checkedCustomTests[i]" [for]="'basic_checkbox_4'+i">Foto (1 crédito)</label>
                              </div>



                              
                            </div>   
                          </div>
                    </div>
                    



                    <div class="form-actions mt-5">
                        <!-- <a *ngIf="!isLocal" [ngStyle]="{backgroundColor : (domainService.customColor$ | async)}" class="btn-info btn-rounded text-white mytooltip btn-sm mr-5" href="javascript:void(0)" style="z-index: 11;" (click)="defaultEmail=!defaultEmail; checkState()">Personalizar envío<span class="tooltip-content4">Aquí podrá personalizar el cuerpo y asunto del email a enviar (Asunto, Tu email y Mensaje de bienvenida).</span></a> -->
                        
                        <button [disabled]="isWorking" type="submit" class="btn btn-info btn-rounded waves-effect m-r-10 pull-right mx-1"> {{isLocal ? 'Crear' : 'Enviar'}}</button>
                        <button type="button" class="btn btn-warning btn-rounded waves-effect pull-right" (click)="reset()">Cancelar</button>
                    </div>
                </form>
            </div>
        </div>
    </div>
</div>




  <div class="modal fade" id="formModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="exampleModalLabel"><b>Formulario a enviar</b></h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div class="modal-body">
          <div class="row">
            <div class="col-12">
              <div class="form-group">
                <label>
                  Seleccionar formulario
                  <select (ngModelChange)="selectForm($event)" [(ngModel)]="selectedFormTitle" class="form-control">
                      <option data-dismiss="modal" (click)="navigateToForms()" value="Crear nuevo">Crear nuevo</option>
                      <option *ngFor="let form of forms" [ngValue]="form._id">{{form.title}}</option>
                  </select>
                </label>
              </div>
            </div>
            <div class="col-12">
              <button type="button" class="btn btn-success btn-sm btn-rounded" (click)="checkScore(formModel, aprovationScore)" data-dismiss="modal">Seleccionar formulario</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

<div class="modal fade" id="infoModal" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
    <div class="modal-dialog modal-lg" role="document">
      <div class="modal-content">
        <div class="modal-header">
          <h4 class="modal-title" id="exampleModalLabel"><b>Competencias por prueba</b></h4>
          <button type="button" class="close" data-dismiss="modal" aria-label="Close">
            <span aria-hidden="true">&times;</span>
          </button>
        </div>

        <div *ngIf="selectedInfo" class="modal-body">
          <div class="row">
            <div class="col-12">
              <div  class="form-group">
                <h3 class="text-center" >{{selectedInfo.type}}</h3>
                <div id="main-description"></div>
                <!-- <p class="my-3">{{selectedInfo.mainDescription}}</p> -->
                <table class="w-100 border-table table-striped table-bordered">
                    <tr>
                        <th *ngIf="selectedInfo.rows[0].imageUrl" ></th>
                        <th class="p-1"><b>Concepto</b></th>
                        <th class="p-1"><b>Descripción</b></th>
                    </tr>
                    <tr *ngFor="let row of selectedInfo.rows" >
                        <td *ngIf="row.imageUrl" class="text-center">
                            <img [src]="row.imageUrl" alt="" class="info-img">
                        </td>
                        <td class="p-1">
                            <p>{{row.title}}</p>
                        </td>
                        <td class="p-1">
                            <p>{{row.description}}</p>
                        </td>
                    </tr>
                </table>
              </div>
            </div>
            <div class="col-12">
                <button type="button" class="btn btn-danger btn-sm btn-rounded pull-right" data-dismiss="modal">Cerrar</button>
              <a type="button" class="btn btn-success btn-sm btn-rounded pull-right mx-1" [href]="selectedInfo.link" target="_blank">Ver reporte</a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>